<app-reusable-modal
  [isOpen]="isOpen"
  [title]="title"
  [contentScoped]="true"
  [centerContent]="true"
  [borderless]="true"
  panelClass="inventory-item-image-viewer__modal"
  (closed)="closed.emit()"
>
  <div class="inventory-item-image-viewer">
    @if (currentImage) {
      <div class="inventory-item-image-viewer__stage">
        <button
          type="button"
          class="inventory-item-image-viewer__nav"
          [disabled]="!canGoPrevious"
          (click)="showPrevious()"
          [attr.aria-label]="'BUTTONS.PREVIOUS' | translate"
        >
          <span aria-hidden="true">&lsaquo;</span>
        </button>

        <div class="inventory-item-image-viewer__image-shell">
          <img
            class="inventory-item-image-viewer__image"
            [src]="currentImage.imageUrl"
            [alt]="title"
            [style.transform]="currentTransform"
          />
        </div>

        <button
          type="button"
          class="inventory-item-image-viewer__nav"
          [disabled]="!canGoNext"
          (click)="showNext()"
          [attr.aria-label]="'BUTTONS.NEXT' | translate"
        >
          <span aria-hidden="true">&rsaquo;</span>
        </button>
      </div>

      <div class="inventory-item-image-viewer__toolbar">
        <button
          type="button"
          class="inventory-item-image-viewer__tool-btn"
          [disabled]="!canZoomOut"
          (click)="zoomOut()"
          [attr.aria-label]="'COMPONENTS.INVENTORY_ITEM_OVERVIEW.ZOOM_OUT' | translate"
        >
          -
        </button>
        <button
          type="button"
          class="inventory-item-image-viewer__tool-btn inventory-item-image-viewer__tool-btn--label"
          (click)="resetZoom()"
        >
          {{ zoomLevel }}x
        </button>
        <button
          type="button"
          class="inventory-item-image-viewer__tool-btn"
          [disabled]="!canZoomIn"
          (click)="zoomIn()"
          [attr.aria-label]="'COMPONENTS.INVENTORY_ITEM_OVERVIEW.ZOOM_IN' | translate"
        >
          +
        </button>
      </div>

      <div class="inventory-item-image-viewer__thumbs">
        @for (image of images; track image.id) {
          <button
            type="button"
            class="inventory-item-image-viewer__thumb"
            [class.inventory-item-image-viewer__thumb--active]="image.id === currentImage.id"
            (click)="selectImage(image.id)"
          >
            <img class="inventory-item-image-viewer__thumb-image" [src]="image.imageUrl" [alt]="title" />
          </button>
        }
      </div>
    }
  </div>
</app-reusable-modal>
